<div [attr.aria-hidden]="isHidden" *ngIf="moduleContent && branding" scAutomaticCall>

  <section data-area="header_modules">
    <sign-on-header [branding] = 'branding'
      [pageData] = 'moduleContent'></sign-on-header>
  </section>
  <section data-area="content" data-layout="unauthenticated_process" data-background="bg-default" class="content row">
      <section data-section="landing_container" class="container">


          <section class="row">
              <section data-area="main" class="col-xs-12 col-sm-12 col-lg-12 col-md-12 no-padding">

                  <sign-on-form [XXXExtra]='XXXExtra' [pageData] = 'moduleContent' ></sign-on-form>

              </section>
          </section>
      </section>
  </section>
  <flex-banner *ngIf="!adBlockerEnabled" ></flex-banner>
  <!-- ngIf !adBlocked -->
  <flex-seo *ngIf="!adBlockerEnabled && !isWayfair && !isSignonFlexSeoDisable" [pageData] = 'moduleContent' [primaryMode]="false"></flex-seo>
  <flex-seo *ngIf="adBlockerEnabled && getPrimaryContentDiffFromFlexSeo() && !isWayfair && !isSignonFlexSeoDisable" [pageData]='moduleContent' [primaryMode]="false"></flex-seo>
  <!-- SEO header tags -->
    <div *ngIf="!adBlockerEnabled" class="visuallyhidden" aria-hidden="true" [innerHTML]="moduleContent?.copy$$signon_seo_header_tags?.TEXT">
    </div>


  <section data-area="footer_modules" class="row p-0">
      <div class="col-12 p-0">
          <contact-us [contactus]='moduleContent'></contact-us>
          <disclosure-banner></disclosure-banner>
          <svc-footer
            [branding]='branding'
            [pageData]='moduleContent'></svc-footer>
      </div>
  </section>


</div>
<popup-content></popup-content>

